import axios from 'axios'
import isEqual from 'is-equal';

export const assertEquals = (a, b) => {
    if (isEqual(a,b)) {
        return {
            success: true,
            notes: ''
        };
    }
    return {
        success: false,
        notes: `Expected ${a} to equal ${b}`
    };
}
export const assertNeverHappens = () => {
    return {
        success: false,
        notes: 'Unexpected error. See developer tools in your browser for more info.'
    };
}
  
export const assertNoError = () => {
    return {
        success: false,
        notes: 'Request failed. See developer tools in your browser for more info.'
    };
}

export const assertNoSuccess = () => {
    return {
        success: false,
        notes: 'This request _should_ fail.'
    };
}

export const assertMultiEquals = (list) => {
    for(let i = 0; i < list.length; i++) {
        if (!isEqual(list[i][1], list[i][2])) {
            return {
                success: false,
                notes: `${list[i][0]}: Expected ${list[i][1]} to equal ${list[i][2]}`
            }
        }
    }
    return {
        success: true,
        notes: ''
    }
}



export const executeTests = (basePath, tests) => {
    const log = [];
    const queue = [];
    tests.forEach(test => {
      
        const logMessage = {
        name: test.name,
            pending: true,
            aborted: false,
            response: {success: false, notes: ""}
        }
        log.push(logMessage);
        queue.push(() => {
            let request = false;
            const url = basePath + test.url + (test.extendPath ? test.extendPath() : '')
            if (test.method === 'post') {
                if(test.payload) {
                    request = axios.post(url, test.payload);
                }else {
                    request = axios.post(url);
                }
            
            } else if (test.method === 'put') {
                request = axios.put(url, test.payload, {headers: {"Content-Type": "application/json"}});
            } else {
                request = axios.get(url);
            }
            return new Promise(function(resolve) {
                request.then(response => {
                    if(!test.handleResponse) {
                        test.handleResponse = assertNoSuccess;
                    }
                    logMessage.response = test.handleResponse(response)
                })
                .catch(error => {
                    if(!test.handleError) {
                        test.handleError = assertNoError;
                    }
                    logMessage.response = test.handleError(error)
                }).finally(() => {
                    logMessage.pending = false
                    resolve(logMessage.response.success);
                })
            })
        })
    });
    processQueue(queue, log);
    return log;
}
  
const processQueue = (tests, log) => {
    const test = tests.shift();
    test().then((success) => {
        if (tests.length > 0 && success) {
            setTimeout(() => {
                processQueue(tests, log);
            }, 100);
        } else {
            log.forEach(test => {
                if(test.pending) {
                    test.pending = false
                    test.aborted = true
                }
            })
        }
    })
}
  
  